import { ComponentType } from 'react';

import { useAppSelector } from '../../../../../../store/hooks';
import { OuterBasicInfoFormProps } from '../../models/outer-basic-info-form.props';

export const withBasicInfoData = <TProps extends OuterBasicInfoFormProps>(
  WrappedComponent: ComponentType<TProps>
): ((props: Omit<TProps, 'basicInfoStateFields'>) => JSX.Element) => {
  return (props: Omit<TProps, 'basicInfoStateFields'>) => {
    const basicInfoFormState = useAppSelector(
      state => state.campaignsFeature.basicInfo.data
    );

    return (
      <WrappedComponent
        {...(props as TProps)}
        basicInfoStateFields={basicInfoFormState}
      />
    );
  };
};
